<div class="card-header">
  <div class="grid-x">
    <div class="cell auto">
      <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
    </div>
    <div class="cell shrink" *ngIf="debtSummary && widget.size  === WidgetSize.LARGE">
      <span class="f-10 c-medium-gray padding-r-xs">
        <span class="fas fa-circle" style="{{'color:' + debtSummary.fixe.color}}"></span>
        {{ 'widget.debt-summary.fixed-rate-type' | translate}}
      </span>
      <span class="f-10 c-medium-gray padding-r-xs">
        <span class="fas fa-circle c-fairways" style="{{'color:' + debtSummary.variable.color}}"></span>
        {{ 'widget.debt-summary.floating-rate-type' | translate}}
      </span>
      <span class="f-10 c-medium-gray">
        <span class="fas fa-circle c-fairways" style="{{'color:' + debtSummary.livretA.color}}"></span>
        {{ 'widget.debt-summary.livret-a-rate-type' | translate}}
      </span>
      <span class="f-10 c-medium-gray">
        <span class="fas fa-circle c-fairways" style="{{'color:' + debtSummary.structure.color}}"></span>
        {{ 'widget.debt-summary.structured-rate-type' | translate}}
      </span>
    </div>
  </div>
</div>

<div *ngIf="debtSummary" class="card-body vertical-center" style="overflow: visible;z-index: 10">

  <div *ngIf="widget.size === WidgetSize.LARGE" class="d-block padding-h">

    <div class="grid-x">
      <div class="cell auto">

        <div class="margin-t-s">
          <span class="label-mao-small c-dark-gray">{{'widget.debt-summary.currently' | translate}}</span>
        </div>
        <div class="d-block pos-relative margin-t-s" style="height:15px;">
          <div class="d-block absolute-top widget-bar"
               [style]="'z-index:4;width:' + clientStructuredRateRepartition + '%;background-color: ' + debtSummary.structure.color">
            <span class="d-block"
                  style="width: 100%; height: 15px"
                  [attr.data-balloon]="('widget.debt-summary.structured-rate-type' | translate) + ' : ' + amountFormatterService.format(debtSummary.structure.amount, '0.0a') + ' (' + (clientStructuredRateRepartition / 100 | percent) + ')'"
                  data-balloon-pos="up"></span>
          </div>


          <div class="d-block absolute-top widget-bar"
               [style]="'z-index:3;width:' + (this.clientLivretARateRepartition + this.clientStructuredRateRepartition) + '%;background-color:' + debtSummary.livretA.color">
            <span class="widget-inline-bar"
                  [attr.data-balloon]="('widget.debt-summary.livret-a-rate-type' | translate) + ' : ' + amountFormatterService.format(debtSummary.livretA.amount, '0.0a') + ' (' + (clientLivretARateRepartition / 100 | percent) + ')'"
                  data-balloon-pos="up"
                  [style]="'width:' + (clientLivretASubRateRepartition < 93 ? clientLivretASubRateRepartition : 100) + '%;'"></span>
            <span *ngIf="(100 - clientLivretASubRateRepartition) > 7"
                  class="widget-inline-bar"
                  [style]="'width:' + (100 - this.clientLivretASubRateRepartition) + '%;'">
            </span>
          </div>

          <div class="d-block absolute-top widget-bar"
               [style]="'z-index:2;width:' + (clientFloatingRateRepartition + clientStructuredRateRepartition + clientLivretARateRepartition) + '%;background-color: ' + debtSummary.variable.color">
            <span class="widget-inline-bar"
                  [attr.data-balloon]="('widget.debt-summary.floating-rate-type' | translate) + ' : ' + amountFormatterService.format(debtSummary.variable.amount, '0.0a') + ' (' + (clientFloatingRateRepartition / 100 | percent) + ')'"
                  data-balloon-pos="up"
                  [style]="'width:' + (clientFloatingSubRateRepartition < 93 ? clientFloatingSubRateRepartition : 100) + '%;'"></span>
            <span *ngIf="(100 - clientFloatingSubRateRepartition) > 7"
                  class="widget-inline-bar"
                  [style]="'width:' + (100 - this.clientFloatingSubRateRepartition) + '%;'"></span>
          </div>


          <div class="d-block absolute-top widget-bar"
               [style]="'z-index:1;width:100%;background-color: ' + debtSummary.fixe.color">
            <span class="widget-inline-bar"
                  [attr.data-balloon]="('widget.debt-summary.fixed-rate-type' | translate) + ' : ' + amountFormatterService.format(debtSummary.fixe.amount, '0.0a') + ' (' + (clientFixedRateRepartition / 100 | percent) + ')'"
                  data-balloon-pos="up"
                  [style]="'width:' + (clientFixedSubRateRepartition < 93 ? clientFixedSubRateRepartition : 100) + '%;'"></span>
            <span *ngIf="(100 - clientFixedSubRateRepartition) > 7"
                  class="widget-inline-bar"
                  [style]="'width:' + (100 - clientFixedSubRateRepartition) + '%;'"></span>
          </div>
        </div>

        <div class="margin-t">
          <span class="label-mao-small c-dark-gray">{{'widget.debt-summary.fa-recommendation' | translate}}</span>
        </div>
        <div class="d-block pos-relative margin-t-s" style="height:15px;">
          <div class="d-block absolute-top background widget-bar"
               [style]="'z-index:2;width:' + debtSummary.floatingRateRecommendation + '%;background-color: ' + debtSummary.variable.color">
            <span class="d-block"
                  style="width: 100%; height: 15px"
                  [attr.data-balloon]="('widget.debt-summary.floating-rate-type' | translate) + ' : ' +  (debtSummary.floatingRateRecommendation / 100 | percent)"
                  data-balloon-pos="up"></span>
          </div>


          <div class="d-block absolute-top widget-bar"
               [style]="'z-index:1;width:100%;'">
            <span class="widget-inline-bar background"
                  [attr.data-balloon]="('widget.debt-summary.fixed-rate-type' | translate) + ' : ' + ((100 - debtSummary.floatingRateRecommendation) / 100 | percent)"
                  data-balloon-pos="up"
                  [style]="'width:' + (100 - (debtSummary.floatingRateRecommendation - 10)) + '%;background-color: ' + debtSummary.fixe.color"></span>
            <span class="widget-inline-bar"
                  [style]="'width:' + (debtSummary.floatingRateRecommendation + 10) + '%;'"></span>
          </div>
        </div>
      </div>

      <div class="margin-l-l cell shrink" style="display: flex;align-items: center">
        <div class="bg-gray-xlight padding-h padding-v"
             style="border-radius: 4px; border-left: solid 8px #280484;height: fit-content">
          <div class="grid-x">
            <div class="cell auto">
              <h3 class="c-medium-gray float-left">{{'widget.debt-summary.crd' | translate}}</h3>
            </div>
          </div>
          <h2 class="c-dark-gray font-bold margin-t-s">{{amountFormatterService.format(debtSummary.crd, '0.0a')}}</h2>
        </div>
      </div>

    </div>
  </div>


  <div *ngIf="widget.size === WidgetSize.SMALL" class="margin-h">
    <div>
      <span class="label-mao-small c-dark-gray">{{'widget.debt-summary.currently' | translate}}</span>
    </div>
    <div class="d-block pos-relative margin-t-s" style="height:15px;">
      <div class="d-block absolute-top widget-bar"
           [style]="'z-index:4;width:' + clientStructuredRateRepartition + '%;background-color: ' + debtSummary.structure.color">
        <span class="d-block"
              style="width: 100%; height: 15px"
              [attr.data-balloon]="('widget.debt-summary.structured-rate-type' | translate) + ' : ' + amountFormatterService.format(debtSummary.structure.amount, '0.0a') + ' (' + (clientStructuredRateRepartition / 100 | percent) + ')'"
              data-balloon-pos="up"></span>
      </div>


      <div class="d-block absolute-top widget-bar"
           [style]="'z-index:3;width:' + (this.clientLivretARateRepartition + this.clientStructuredRateRepartition) + '%;background-color:' + debtSummary.livretA.color">
        <span class="widget-inline-bar"
              [attr.data-balloon]="('widget.debt-summary.livret-a-rate-type' | translate) + ' : ' + amountFormatterService.format(debtSummary.livretA.amount, '0.0a') + ' (' + (clientLivretARateRepartition / 100 | percent) + ')'"
              data-balloon-pos="up"
              [style]="'width:' + (clientLivretASubRateRepartition < 93 ? clientLivretASubRateRepartition : 100) + '%;'"></span>
        <span *ngIf="(100 - clientLivretASubRateRepartition) > 7"
              class="widget-inline-bar"
              [style]="'width:' + (100 - this.clientLivretASubRateRepartition) + '%;'">
        </span>
      </div>

      <div class="d-block absolute-top widget-bar"
           [style]="'z-index:2;width:' + (clientFloatingRateRepartition + clientStructuredRateRepartition + clientLivretARateRepartition) + '%;background-color: ' + debtSummary.variable.color">
        <span class="widget-inline-bar"
              [attr.data-balloon]="('widget.debt-summary.floating-rate-type' | translate) + ' : ' + amountFormatterService.format(debtSummary.variable.amount, '0.0a') + ' (' + (clientFloatingRateRepartition / 100 | percent) + ')'"
              data-balloon-pos="up"
              [style]="'width:' + (clientFloatingSubRateRepartition < 93 ? clientFloatingSubRateRepartition : 100) + '%;'"></span>
        <span *ngIf="(100 - clientFloatingSubRateRepartition) > 7"
              class="widget-inline-bar"
              [style]="'width:' + (100 - this.clientFloatingSubRateRepartition) + '%;'"></span>
      </div>


      <div class="d-block absolute-top widget-bar"
           [style]="'z-index:1;width:100%;background-color: ' + debtSummary.fixe.color">
        <span class="widget-inline-bar"
              [attr.data-balloon]="('widget.debt-summary.fixed-rate-type' | translate) + ' : ' + amountFormatterService.format(debtSummary.fixe.amount, '0.0a') + ' (' + (clientFixedRateRepartition / 100 | percent) + ')'"
              data-balloon-pos="up"
              [style]="'width:' + (clientFixedSubRateRepartition < 93 ? clientFixedSubRateRepartition : 100) + '%;'"></span>
        <span *ngIf="(100 - clientFixedSubRateRepartition) > 7"
              class="widget-inline-bar"
              [style]="'width:' + (100 - clientFixedSubRateRepartition) + '%;'"></span>
      </div>
    </div>

    <div class="margin-t">
      <span class="label-mao-small c-dark-gray">{{'widget.debt-summary.fa-recommendation' | translate}}</span>
    </div>
    <div class="d-block pos-relative margin-t-s" style="height:15px;">
      <div class="d-block absolute-top background widget-bar"
           [style]="'z-index:2;width:' + debtSummary.floatingRateRecommendation + '%;background-color: ' + debtSummary.variable.color">
        <span class="d-block"
              style="width: 100%; height: 15px"
              [attr.data-balloon]="('widget.debt-summary.floating-rate-type' | translate) + ' : ' +  (debtSummary.floatingRateRecommendation / 100 | percent)"
              data-balloon-pos="up"></span>
      </div>


      <div class="d-block absolute-top widget-bar"
           [style]="'z-index:1;width:100%;'">
        <span class="widget-inline-bar background"
              [attr.data-balloon]="('widget.debt-summary.fixed-rate-type' | translate) + ' : ' + ((100 - debtSummary.floatingRateRecommendation) / 100 | percent)"
              data-balloon-pos="up"
              [style]="'width:' + (100 - (debtSummary.floatingRateRecommendation - 10)) + '%;background-color: ' + debtSummary.fixe.color"></span>
        <span class="widget-inline-bar"
              [style]="'width:' + (debtSummary.floatingRateRecommendation + 10) + '%;'"></span>
      </div>
    </div>

  </div>
</div>
<div class="card-footer">
  <a class="button insito" [href]="goToMonthlySummaryPage()"
     (click)="actionEvent.emit('widget.debt-summary.download-monthly-summary')">
    <span
      [title]="'widget.debt-summary.download-monthly-summary' | translate">{{ 'widget.debt-summary.download-monthly-summary' | translate}}</span>
  </a>
</div>
